//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
export default {
  data() {
    return {
       loadComplete: false,
       selected: [],
       pagination: {
        rowsPerPage: 0, 
        page: 1,
        sortBy: "supplierName",
      },
       orderItems: [],
       columns: [
          {
           name: "supplierName",
           align: "left",
           label: "Leverandør navn",
           field: "supplierName",
           sortable: true,
         },
         {
           name: "productNumber",
           align: "left",
           label: "Produktnummer",
           field: "productNumber",
           sortable: true,
         },
         {
           name: "productName",
           align: "left",
           label: "Produktnavn",
           field: "productName",
           sortable: true,
         },
          {
           name: "productUnit",
           align: "left",
           label: "Enhet",
           field: "productUnit",
           sortable: true,
         },
          {
           name: "ItemsInStock",
           align: "left",
           label: "På lager",
           field: "itemsInStock",
           sortable: true,
         },
          {
           name: "ItemsOutgoing",
           align: "left",
           label: "På vei ut",
           field: "itemsOutgoing",
           sortable: true,
         },
          {
           name: "ItemsIncoming",
           align: "left",
           label: "På vei inn",
           field: "itemsIncoming",
           sortable: true,
         },
           {
           name: "Minimum",
           align: "left",
           label: "Min",
           field: "minimum",
           sortable: true,
         },
         {
           name: "Maximum",
           align: "left",
           label: "Maks",
           field: "maximum",
           sortable: true,
         },
          {
           name: "numberOfItems",
           align: "left",
           label: "Antall til bestilling",
           field: "numberOfItems",
           sortable: true,
         }       
       ]     
    }
  },

  async mounted() {
    await this.refresh();
  },

  
  methods: {   

    async refresh() {
      this.orderItems = [];
      this.loadComplete = false;
      const notif = this.$q.notify({
        message: "Laster data...",
        timeout: 0,
        spinner:true,
      });

      this.getSuggestedOrderItems().then((result) =>{
        this.orderItems = result;
        notif();
        this.loadComplete = true;
      });
    },
    async createPurchaseOrders () {

      var items = [];
      this.selected.forEach(function(item) {
        var newItem = {};
        newItem.productId = item.productId;
        newItem.itemText = item.productName;
        newItem.numberOfItems = item.numberOfItems;
        items.push(newItem)
      });

      try{      
        await this.postPurchaseOrderFromOrderItems(items);
        this.refresh();
        this.$notify({
              group: "foo",
              title: "",
              text: this.$t("common.saveOk"),
            });
        }
        catch (error) 
        {
          console.log("error", error);
          this.$notify({
            group: "foo",
            title: this.$t("common.errorSave"),
            text: error,
            type: "error",
        });
      }
    },


    ...mapActions("main", ["getSuggestedOrderItems", "postPurchaseOrderFromOrderItems"]),
  },
};
